import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { DEFAULT_LANGUAGE } from 'constants/language';
import hasNorwegianPrefix from './hasNorwegianPrefix';
import isEmptyNumber from './isEmptyNumber';
export default (phoneNr, allowEmpty = false) => {
  if (isEmptyNumber(phoneNr)) return allowEmpty;
  if (hasNorwegianPrefix(phoneNr) && (phoneNr.length !== 11 || ['0', '1'].includes(phoneNr[3]))) {
    return false;
  }
  return isPossiblePhoneNumber(phoneNr, DEFAULT_LANGUAGE);
};